export default () => {
  let resizingTimeout = 0;
  
  // document.body.classList.add('reduced-motion');
  document.addEventListener('DOMContentLoaded', () => document.body.classList.remove('reduced-motion'));

  window.addEventListener('resize', () => {
    document.body.classList.add('reduced-motion');
    if (!resizingTimeout) {
      resizingTimeout = setTimeout(() => {
        document.body.classList.remove('reduced-motion');
        clearTimeout(resizingTimeout);
        resizingTimeout = 0;
      }, 1000);
    }
  });
};
